var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BarChartIcon from "@mui/icons-material/BarChart";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Card, CardContent, CardHeader, Grid, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRetrievePlayersByTeamId, useRetrieveTeam } from "../ApiProvider";
import { useDeleteExternalMatch, useRetrieveExternalMatch, } from "../api/MatchApiProvider";
import { useRetrieveUserExternalMatchPermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { findPlayerById } from "../players/utils";
import { extractYoutubeVideoId } from "../stats/ExternalMatchStatsForm";
import { formatScorer, formatSentOff } from "../stats/ScorerFormatter";
import { findPlayerExternalMatchStatByPlayerId } from "../stats/utils";
import { SquadCard } from "../teams/SquadCard";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { ResponsiveActionMenu, } from "../utils/ResponsiveActionMenu";
import { useNumericParams } from "../utils/useNumericParams";
import { MatchDateTimeHeader } from "./MatchDateTimeHeader";
import { MatchScoreboard } from "./MatchScoreboard";
var ExternalMatch = function () {
    var _a, _b, _c, _d, _e;
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _f = __read(React.useState(false), 2), showDelete = _f[0], setShowDelete = _f[1];
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _g = useRetrieveUserExternalMatchPermissions({ externalMatchId: id }), userExternalMatchPermissions = _g.data, userExternalMatchPermissionsIsLoading = _g.isLoading, userExternalMatchPermissionsError = _g.error;
    var _h = userExternalMatchPermissions || {}, _j = _h.canModify, canModify = _j === void 0 ? false : _j, _k = _h.canView, canView = _k === void 0 ? false : _k, _l = _h.canModifyStats, canModifyStats = _l === void 0 ? false : _l;
    var _m = useRetrieveExternalMatch({ id: id, enabled: canView }), externalMatchIsLoading = _m.isLoading, externalMatchError = _m.error, externalMatch = _m.data;
    var _o = useRetrieveTeam({ id: externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team }), useRetrieveTeamIsLoading = _o.isLoading, useRetrieveTeamError = _o.error, team = _o.data;
    var mutation = useDeleteExternalMatch({
        externalMatch: externalMatch,
        team: team,
        onMutate: function () { },
        onSuccess: function () {
            return navigate("/teams/".concat(externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team));
        },
        onError: function () { },
    });
    var _p = useRetrievePlayersByTeamId({ teamId: externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.team }), allPlayers = _p.data, playersError = _p.error, playersIsLoading = _p.isLoading;
    var getPlayer = findPlayerById(allPlayers || []);
    var getPlayerExternalMatchStat = findPlayerExternalMatchStatByPlayerId((externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.playerExternalMatchStats) || []);
    var players = (_a = externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.players) === null || _a === void 0 ? void 0 : _a.map(getPlayer).filter(function (player) { return player !== undefined; });
    var scorers = players === null || players === void 0 ? void 0 : players.map(function (player) {
        var stats = getPlayerExternalMatchStat(player.id);
        return formatScorer(player, stats);
    }).filter(function (scorer) { return scorer !== undefined; });
    var sentOff = players === null || players === void 0 ? void 0 : players.map(function (player) {
        return formatSentOff(player, getPlayerExternalMatchStat(player.id));
    }).filter(function (name) { return name !== undefined; });
    if (userExternalMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (!canView) {
        return _jsx(NotFound, {});
    }
    if (userExternalMatchPermissionsError) {
        return _jsx(ErrorView, { error: userExternalMatchPermissionsError });
    }
    if ((externalMatchIsLoading && canView) ||
        mutation.isLoading ||
        playersIsLoading ||
        useRetrieveTeamIsLoading) {
        return _jsx(Loading, {});
    }
    if (id === undefined) {
        return _jsx(NotFound, {});
    }
    if (useRetrieveTeamError ||
        externalMatchError ||
        playersError ||
        !externalMatch ||
        !team) {
        return _jsx(ErrorView, {});
    }
    var actions = __spreadArray(__spreadArray([], __read((canModify || canModifyStats
        ? [
            {
                icon: _jsx(BarChartIcon, {}),
                label: "Edit Stats",
                to: "/teams/".concat(team.id, "/external-matches/").concat(id, "/stats/update/"),
            },
        ]
        : [])), false), __read((canModify
        ? [
            {
                icon: _jsx(EditIcon, {}),
                label: "Edit Match",
                to: "/teams/".concat(team.id, "/external-matches/").concat(id, "/update"),
            },
            {
                icon: _jsx(DeleteIcon, {}),
                label: "Delete",
                onClick: function () { return setShowDelete(true); },
            },
        ]
        : [])), false);
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to delete match. Please try again!" }), _jsx(DeleteDialog, { open: showDelete, title: "Delete External Match?", onCancel: function () { return setShowDelete(false); }, onConfirm: function () { return mutation.mutate(); } }), _jsxs(Card, { sx: { mb: 3 }, children: [_jsx(CardHeader, { title: _jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [_jsx(Box, { sx: { flex: 1 } }), _jsx(MatchDateTimeHeader, { kickOff: externalMatch.kickOff, subtitle: _jsx(Link, { style: { textDecoration: "none" }, to: "/teams/".concat(team.id), children: _jsx(Typography, { variant: "body2", color: "primary.main", sx: { "&:hover": { textDecoration: "underline" } }, children: team.name }) }) }), _jsx(Box, { sx: { flex: 1, display: "flex", justifyContent: "flex-end" }, children: (canModify || canModifyStats) && (_jsx(ResponsiveActionMenu, { actions: actions, isMobile: isMobile })) })] }) }), _jsx(CardContent, { children: _jsx(MatchScoreboard, { team1: { name: team.name, link: "/teams/".concat(team.id) }, team2: { name: externalMatch.opponentTeam.name }, score1: (_b = externalMatch.externalMatchResult) === null || _b === void 0 ? void 0 : _b.teamScore, score2: (_c = externalMatch.externalMatchResult) === null || _c === void 0 ? void 0 : _c.opponentTeamScore, scorers1: scorers, scorers2: [], sentOff1: sentOff, sentOff2: [] }) })] }), _jsx(Grid, { container: true, spacing: 2, sx: { mb: 3 }, children: _jsx(Grid, { item: true, xs: 12, children: _jsx(SquadCard, { title: _jsx(Typography, { align: "center", variant: "subtitle2", children: "Squad" }), players: players || [], getPlayerStat: getPlayerExternalMatchStat }) }) }), _jsxs(Grid, { container: true, spacing: 2, sx: { mb: 3 }, children: [((_d = externalMatch.externalMatchResult) === null || _d === void 0 ? void 0 : _d.matchReport) && (_jsx(Grid, { item: true, xs: 12, md: 6, children: _jsxs(Card, { children: [_jsx(CardHeader, { title: _jsx(Typography, { variant: "subtitle2", textAlign: "center", children: "Match Report" }) }), _jsx(CardContent, { children: _jsx(Typography, { variant: "body1", whiteSpace: "pre-line", children: externalMatch.externalMatchResult.matchReport }) })] }) })), ((_e = externalMatch.externalMatchResult) === null || _e === void 0 ? void 0 : _e.highlightsYoutubeUrl) &&
                        extractYoutubeVideoId(externalMatch.externalMatchResult.highlightsYoutubeUrl) && (_jsx(Grid, { item: true, xs: 12, md: 6, children: _jsxs(Card, { children: [_jsx(CardHeader, { title: _jsx(Typography, { variant: "subtitle2", textAlign: "center", children: "Highlights" }) }), _jsx(CardContent, { children: _jsx(Box, { display: "flex", justifyContent: "center", children: _jsx(Box, { component: "iframe", width: "100%", height: "315", src: "https://www.youtube.com/embed/".concat(extractYoutubeVideoId(externalMatch.externalMatchResult.highlightsYoutubeUrl)), title: "YouTube video preview", frameBorder: "0", style: { borderRadius: 8, maxWidth: 560 }, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }) }) })] }) }))] })] }));
};
export default ExternalMatch;
